// extracted by mini-css-extract-plugin
module.exports = {"title":"_3gEJ4","text":"_3ehPL","retunButton":"_3CT8G","container":"_2Ot96"};